/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import messages from '../../../messages';
import { LogoSvg } from '@atlassian/generative-ai-modal/assets/Logo';
import { floatingAIButtonWrapperStyles, floatingAIButtonStyles, FLOATING_AI_ICON_SIZE } from './styles';
import Tooltip from '@atlaskit/tooltip';
export const FloatingAiButton = props => {
  const {
    formatMessage
  } = useIntl();
  const {
    positionLeft,
    positionTop,
    onClick,
    contentHeight
  } = props;
  const logoAltmessage = useMemo(() => formatMessage(messages.logoAltText), [formatMessage]);
  const style = {
    '--position-top': `${positionTop}px`,
    '--position-left': `${positionLeft}px`,
    '--content-height': `${contentHeight}px`
  };
  const tooltipContent = formatMessage(messages.floatingAiButtonTooltip);
  return jsx("div", {
    "data-testid": "floating-ai-button",
    css: floatingAIButtonWrapperStyles,
    style: style
  }, jsx(Tooltip, {
    content: tooltipContent,
    truncate: true
  }, jsx("button", {
    type: "button",
    onClick: onClick,
    css: floatingAIButtonStyles
  }, jsx(LogoSvg, {
    alt: logoAltmessage,
    size: FLOATING_AI_ICON_SIZE
  }))));
};